<template>
    <header id="site-header"
            :class="{ white: white }">
        <nav>
            <div class="label" v-scroll-to="'#section-why-us'">WHY US</div>
            <div class="seperator"> > </div>
            <div class="label" v-scroll-to="'#section-work'">WORK</div>
            <div class="seperator"> > </div>
            <div class="label" v-scroll-to="'#section-talking'">TALKING</div>
            <div class="seperator"> > </div>
            <div class="label" v-scroll-to="'#section-job'">JOB</div>
             <div class="seperator"> > </div>
            <div class="label" v-scroll-to="'#section-qa'">QA</div>
<!--             <div class="seperator"> > </div>
            <div class="label" v-scroll-to="'#section-apply'">APPLY</div> -->
        </nav>
    </header>
</template>

<script>
export default {
    name: 'SiteHeader',
    props: ["white"],
}
</script>

<style scoped 
       lang="scss">
    @import "../static/styles/palette.scss";
    
    header {
        display: flex;
        justify-content: center;
        position: fixed;
        top: 0;
        z-index: 100;
        width: 100%;        
        height: 55px;
        background-color: white;
        box-sizing: border-box;
        border-style: solid;
        border-width: 12px 12px 0px 12px;
        border-color: $blue;

        & nav {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 600px;
            white-space: nowrap;
        }
        & .label {
            color: $blue;
            cursor: pointer;
        }
        & .label:hover {
            border-bottom: 4px solid $blue;
        }
        & .label, & .seperator {            
            font-family: "Roboto";
            font-size: 20px;
            font-stretch: condensed;
            font-style: italic;
            margin: 0 10px;
        }
        & .seperator {
            color: $darkGray;
        }
    }

    header.white {
        background-color: $blue;

        & .label, & .seperator {
            color: white;
        }
        & .label:hover {
            border-bottom: 4px solid white;
        }
    }

    @media all and (max-width: 680px) {
        header {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// Header.vue?0ce49f3d